// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1G5o0","head":"style_head__3nTqa"};